import React from 'react';

export const OM = () => {
	return (
		<svg
			width='20'
			height='15'
			viewBox='0 0 20 15'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
		>
			<g clipPath='url(#clip0_11534_5877)'>
				<mask
					id='mask0_11534_5877'
					style={{ maskType: 'luminance' }}
					maskUnits='userSpaceOnUse'
					x='0'
					y='0'
					width='20'
					height='15'
				>
					<rect width='20' height='15' fill='white' />
				</mask>
				<g mask='url(#mask0_11534_5877)'>
					<path
						fillRule='evenodd'
						clipRule='evenodd'
						d='M0 0V15H20V0H0Z'
						fill='#F50101'
					/>
					<mask
						id='mask1_11534_5877'
						style={{ maskType: 'luminance' }}
						maskUnits='userSpaceOnUse'
						x='0'
						y='0'
						width='20'
						height='15'
					>
						<path
							fillRule='evenodd'
							clipRule='evenodd'
							d='M0 0V15H20V0H0Z'
							fill='white'
						/>
					</mask>
					<g mask='url(#mask1_11534_5877)'>
						<path
							fillRule='evenodd'
							clipRule='evenodd'
							d='M0 0V5H20V0H0Z'
							fill='#F7FCFF'
						/>
						<path
							fillRule='evenodd'
							clipRule='evenodd'
							d='M0 10V15H20V10H0Z'
							fill='#5EAA22'
						/>
						<rect width='7.5' height='15' fill='#F50101' />
						<path
							fillRule='evenodd'
							clipRule='evenodd'
							d='M6.73148 1.27055C6.7374 1.21353 6.66447 1.1916 6.63539 1.24099C6.40859 1.62627 5.84011 2.5428 4.90432 3.74135V3.1678C4.81506 3.07079 4.53049 2.8098 4.53049 2.8098V2.2371L5.04529 1.77123L4.33825 1.25001L3.59303 1.77123L4.15631 2.2371V2.8098C4.15631 3.08442 3.81482 3.1678 3.81482 3.1678L3.75229 3.67298C2.8817 2.54248 2.33892 1.66102 2.10907 1.26704C2.0794 1.2162 2.00479 1.24015 2.01355 1.29836C2.08293 1.75908 2.29043 2.78133 2.86361 3.87279H2.70988V3.85247C2.70988 3.82245 2.68555 3.79812 2.65553 3.79812H1.3376C1.30758 3.79812 1.28325 3.82245 1.28325 3.85247V4.68127C1.28325 4.71129 1.30758 4.73562 1.3376 4.73562H2.65553C2.68555 4.73562 2.70988 4.71129 2.70988 4.68127V4.24615H2.87586C2.93216 4.37596 3.06144 4.46745 3.21263 4.4701C3.31825 4.63306 3.43279 4.79557 3.557 4.95605C3.27128 4.92779 1.38293 4.76702 1.38293 5.45401C1.38293 5.86408 1.84223 6.08113 2.41826 6.19332C1.83826 6.71854 1.29081 7.21271 1.03894 7.43996C0.998068 7.47683 1.03001 7.5407 1.08344 7.52746C1.53324 7.41599 2.71227 7.07207 3.83467 6.30637L3.86963 6.30641C4.18573 6.30641 4.40558 6.16928 4.55839 5.98368C5.69997 6.9155 6.99147 7.34586 7.55209 7.50006C7.61026 7.51606 7.64171 7.44077 7.59215 7.40637C7.13679 7.0903 6.10998 6.32962 5.06005 5.22474L5.0876 5.19249C5.30181 4.9397 5.48846 4.67968 5.65109 4.41896C5.71914 4.37917 5.77333 4.31863 5.80477 4.24615H5.97075V4.68127C5.97075 4.71129 5.99508 4.73562 6.0251 4.73562H7.34303C7.37305 4.73562 7.39738 4.71129 7.39738 4.68127V3.85247C7.39738 3.82245 7.37305 3.79812 7.34303 3.79812H6.0251C6.01118 3.79812 5.99849 3.80335 5.98887 3.81195C6.52782 2.72102 6.68605 1.70876 6.73148 1.27055ZM5.97075 3.87279V3.85247L5.97093 3.84802L5.95846 3.87279H5.97075ZM3.5251 4.10054C3.5251 4.26756 3.38823 4.40296 3.21939 4.40296C3.05055 4.40296 2.91368 4.26756 2.91368 4.10054C2.91368 3.93352 3.05055 3.79812 3.21939 3.79812C3.38823 3.79812 3.5251 3.93352 3.5251 4.10054ZM5.15553 4.10054C5.15553 4.26756 5.2924 4.40296 5.46124 4.40296C5.63008 4.40296 5.76695 4.26756 5.76695 4.10054C5.76695 3.93352 5.63008 3.79812 5.46124 3.79812C5.2924 3.79812 5.15553 3.93352 5.15553 4.10054Z'
							fill='#F7FCFF'
						/>
					</g>
				</g>
			</g>
			<rect
				x='0.5'
				y='0.5'
				width='19'
				height='14'
				rx='1'
				stroke='black'
				strokeOpacity='0.1'
			/>
			<defs>
				<clipPath id='clip0_11534_5877'>
					<rect width='20' height='15' rx='1.5' fill='white' />
				</clipPath>
			</defs>
		</svg>
	);
};
